import React, { useRef } from "react";
import { toast } from "react-toastify";
// import arrow from "../../assets/svg/arrowRightNew.svg";
import styles from "./StoryWrapper.module.scss";
import arrow from '../../assets/images/Arrow2.png'

const SelectedImage = ({ imageArray, setImageArray, setOpenCrop, setSelectedImageShow }) => {
	const inputRef = useRef();

	const handelRemoveImage = (indexToRemove) => {
		const updatedArray = imageArray.filter((_, index) => index !== indexToRemove);
		setImageArray(updatedArray);
	};

	const handelAddPhotos = (e) => {
		const file = e.target.files;
		if (file) {
			let tempArray = Array(...file);
			setImageArray((prev) => [...prev, ...tempArray]);
		}

		e.target.value = null;
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	const handelDrop = (e) => {
		e.preventDefault();
		const file = e.dataTransfer.files[0];
		setImageArray((prev) => [...prev, file]);
	};

	const handelArrowButton = () => {
		if (imageArray.length === 0) toast.error("Please Select an Image !");
		else {
			setSelectedImageShow(false);
			setOpenCrop(true);
		}
	};

	return (
		<div className={styles.SelectedImageWrapper}>
			<div className={styles.Top}>
				{/* <h1>fameo-X</h1> */}
				<h1>fameo-X</h1>
				<img src={arrow} alt="" onClick={handelArrowButton} />
			</div>

			<div className={styles.Bottom} onDrop={handelDrop} onDragOver={handleDragOver}>
				<div className={styles.ImageSection}>
					{imageArray?.map((data, index) => {
						return (
							<div key={index} className={styles.ImageWrapper}>
								<div className={styles.remove} onClick={() => handelRemoveImage(index)}>
									X
								</div>
								<img src={data instanceof Blob ? URL.createObjectURL(data) : data} alt="" />
							</div>
						);
					})}
				</div>

				<div className={styles.TextSection}>
					<h1>Drag & Drop your image or video</h1>
					<h4>Or</h4>
					<input type="file" multiple ref={inputRef} style={{ display: "none" }} onChange={handelAddPhotos} />
					<button onClick={() => inputRef.current.click()}>Upload from computer</button>
				</div>
			</div>
		</div>
	);
};

export default SelectedImage;


